import VideoDialog from "@elements/Player/VideoDialog";
import useSwrApi from "@hooks/useSwrApi";
import { type LatestVideoResponse } from "@transformer/useBrightcoveResponse";
import { useState } from "react";

import MediaCard from "./MediaCard";

export default function VideoPackage() {
  const { data: videos } = useSwrApi<LatestVideoResponse[]>("latest-videos");

  const [videoDialog, setVideoDialog] = useState({
    visible: false,
    source: "",
  });

  const openVideoDialog = (source?: string) => {
    setVideoDialog({
      visible: true,
      source: source || "",
    });
  };

  const closeVideoDialog = (source?: string) => {
    setVideoDialog({
      visible: false,
      source: source || "",
    });
  };

  return (
    <>
      {videos ? (
        <>
          <MediaCard<LatestVideoResponse>
            variant="Videos"
            renderedThumbnail={videos.slice(0, 10)}
            handleOnClickCallback={openVideoDialog}
            moreLink={{
              destination: "videos",
            }}
          />
          <VideoDialog
            videoDialog={videoDialog}
            handleOnClickCloseDialog={closeVideoDialog}
          />
        </>
      ) : null}
    </>
  );
}
